import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { CoreService } from '../../../../core/core.service';
import { EnvironmentService } from '../../../../core/environment.service';
import { IGender } from '../../../shared/models/basic.model';
import { TitleBarFilter } from '../../../shared/title-bar/models/FilterEnum';
import { BetterRequestService } from '@services';

@Injectable({
    providedIn: 'root',
})
export class GenderService {
    private environmentService = inject(EnvironmentService);
    private readonly betterRequestService = inject(BetterRequestService);
    private http = inject(HttpClient);
    private coreService = inject(CoreService);

    public method: string;
    public gender?: IGender;
    public filter: TitleBarFilter;
    public addedGender?: IGender;

    public init() {
        this.gender = undefined;
        this.addedGender = undefined;
    }

    public getGenderById(id: number): Observable<IGender> {
        let url = this.environmentService.getURL(this.environmentService.appSettings.fakeServer) + '/gender/get';
        if (!this.environmentService.appSettings.fakeServer) {
            url = url + '?Id=' + id;
            url = url + '&language=' + this.environmentService.appSettings.locale;
        }
        return this.betterRequestService.withoutErrorHandler(this.http
            .get<IGender>(url, {
                headers: this.environmentService.appSettings.headers,
                observe: 'response',
            }))
            .pipe(
                map((response) => response.body as IGender),
                catchError(this.coreService.handleError),
            );
    }

    public editGender(gender: IGender): Observable<boolean> {
        const url: string = this.environmentService.getURL(this.environmentService.appSettings.fakeServer) + '/gender/edit';

        return this.betterRequestService.withoutErrorHandler(this.http
            .post<IGender>(url, gender, {
                headers: this.environmentService.appSettings.headers,
                observe: 'response',
            }))
            .pipe(
                map((response) => {
                    if (this.environmentService.appSettings.showLog) {
                        console.log(new Date() + ': ' + 'gender.service.ts - editGender RESPONSE');
                    }

                    this.gender = response.body;
                    this.environmentService.genderList[this.environmentService.genderList.findIndex((g) => g.id === this.gender.id)] = this.gender;
                    this.environmentService.genderHash.set(this.gender.id, this.gender);
                    this.environmentService.genderList = this.environmentService.genderList.concat();
                    return true;
                }),
                catchError(this.coreService.handleError),
            );
    }

    public createGender(gender: IGender): Observable<boolean> {
        const url: string =
            this.environmentService.getURL(this.environmentService.appSettings.fakeServer) +
            '/gender/create' +
            '?language=' +
            this.environmentService.appSettings.locale;
        return this.betterRequestService.withoutErrorHandler(this.http
            .post<IGender>(url, gender, {
                headers: this.environmentService.appSettings.headers,
                observe: 'response',
            }))
            .pipe(
                map((response) => {
                    if (this.environmentService.appSettings.showLog) {
                        console.log(new Date() + ': ' + 'gender.service.ts - createGender RESPONSE');
                    }
                    if (this.environmentService.appSettings.fakeServer) {
                        this.addedGender = response.body;
                        this.addedGender.attributeLocale = gender.attributeLocale;
                        this.addedGender.descr = gender.descr;
                        this.addedGender.sdescr = gender.sdescr;
                        this.addedGender.sortnumber = this.environmentService.genderList[this.environmentService.genderList.length - 1].sortnumber + 1;
                        this.addedGender.styleClass = gender.styleClass;
                        this.addedGender.unknown = gender.unknown;
                        this.addedGender.msgkeySalutation = gender.msgkeySalutation;
                        this.addedGender.locked = gender.locked;
                    } else {
                        this.gender = response.body;
                    }
                    return true;
                }),
                catchError(this.coreService.handleError),
            );
    }

    public lockGender(genderId: number): Observable<boolean> {
        let url: string = this.environmentService.getURL(this.environmentService.appSettings.fakeServer) + '/gender/lock';
        if (!this.environmentService.appSettings.fakeServer) {
            url += '?genderId=' + genderId + '&language=' + this.environmentService.appSettings.locale;
        }
        return this.betterRequestService.withoutErrorHandler(this.http
            .post(url, null, {
                headers: this.environmentService.appSettings.headers,
                observe: 'response',
            }))
            .pipe(
                map((_response) => {
                    if (this.environmentService.appSettings.showLog) {
                        console.log(new Date() + ': ' + 'gender.service.ts - lockGender RESPONSE');
                    }
                    this.gender.locked = !this.gender.locked;
                    this.environmentService.genderList.forEach((g) => (g.id === genderId ? (g.locked = this.gender.locked) : null));
                    return true;
                }),
                catchError(this.coreService.handleError),
            );
    }

    public deleteGender(genderId: number): Observable<boolean> {
        let url: string = this.environmentService.getURL(this.environmentService.appSettings.fakeServer) + '/gender/delete';
        if (!this.environmentService.appSettings.fakeServer) {
            url += '?genderId=' + genderId;
        }
        return this.betterRequestService.withoutErrorHandler(this.http
            .delete(url, {
                headers: this.environmentService.appSettings.headers,
                observe: 'response',
            }))
            .pipe(
                map((response) => {
                    if (this.environmentService.appSettings.showLog) console.log(new Date() + ': ' + 'gender.service.ts - deleteGender RESPONSE');
                    this.gender.deleted = true;
                    this.environmentService.genderList.splice(
                        this.environmentService.genderList.findIndex((g) => g.id === genderId),
                        1,
                    );
                    this.environmentService.genderList = this.environmentService.genderList.concat();
                    return true;
                }),
                catchError(this.coreService.handleError),
            );
    }
}
